import classNames from 'classnames';
import { FC, useState } from 'react';
import { isDesktop } from 'react-device-detect';
import { Arrows } from 'src/components/base-components/Slider/components/Arrows';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const pagination = {
  clickable: true,
  renderBullet: function (index: number, className: string) {
    return '<span class="' + className + '" key="' + index + '"></span>';
  },
};

export const SignupSlider: FC<{ images: string[] }> = ({ images }) => {
  const [my_swiper, set_my_swiper] = useState<any>({});

  return (
    <div className={classNames('banner_container')}>
      <Swiper
        className="carousel_container"
        slidesPerView={1}
        spaceBetween={24}
        autoplay={{
          delay: 5000,
        }}
        speed={1500}
        slidesPerGroup={1}
        loop
        pagination={pagination}
        navigation={{ nextEl: '.arrow-right', prevEl: '.arrow-left' }}
        modules={[Pagination, Navigation, Autoplay]}
        onInit={(ev: any) => set_my_swiper(ev)}
      >
        {images.map((src, i: number) => {
          return (
            <SwiperSlide key={src + i}>
              <div className="carousel_item_container">
                <img className="signupSliderItem" src={src} alt="" />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      {isDesktop && images.length > 1 && (
        <Arrows
          type={''}
          rows={1}
          placement="center"
          template={''}
          size={'md'}
          nextClick={() => my_swiper?.slideNext()}
          prevClick={() => my_swiper?.slidePrev()}
        />
      )}
    </div>
  );
};
